'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TraceTypeScatterternaryIcon = function TraceTypeScatterternaryIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 46 46' }, props),
        _react2.default.createElement('path', { fill: 'none', d: 'M0 0h46v46H0z' }),
        _react2.default.createElement('path', { fill: '#25fdfc', d: 'M23 6l17 32H6L23 6z' }),
        _react2.default.createElement('circle', { cx: '19', cy: '22', r: '2', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '23', cy: '17', r: '2', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '23', cy: '30', r: '2', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '27', cy: '26', r: '2', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '17', cy: '35', r: '2', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '28', cy: '34', r: '2', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '11', cy: '35', r: '2', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '32', cy: '30', r: '2', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '23', cy: '12', r: '2', fill: '#1d9bfb' }),
        _react2.default.createElement('circle', { cx: '35', cy: '35', r: '2', fill: '#1d9bfb' })
    );
};

exports.default = TraceTypeScatterternaryIcon;